import React, { useContext } from 'react'
import { useNavigate, useLocation } from 'react-router'
import { TertiaryButton } from '@entur/button'
import { HorizontalDotsIcon, UsersIcon } from '@entur/icons'
import { OverflowMenu, OverflowMenuItem } from '@entur/menu'
import { useEmployee } from '../../contexts/employee-context'
import { useFamilyMembers } from '../../contexts/family-members-context'
import { WelcomeLetter } from '../welcome-letter/welcome-letter'
import { PostalAddress } from '../post-address-modal/postal-address'
import { DisclosureDocument } from '../disclosure-document/disclosure-document'
import { HistoryState } from '../../types'
import { useClientInfo } from '../../contexts/client-info-context'
import { ReadOnlyContext } from '../../contexts/read-only-context'
import { RestoreEmployee } from '../open-employee-modal/restore-employee'

type EmployeeOverflowMenuProps = {
  disabled?: boolean
  setErrorMessage: (errorMsg: string | undefined) => void
}

export const EmployeeOverflowMenu: React.FC<EmployeeOverflowMenuProps> = ({ disabled, setErrorMessage }) => {
  const navigate = useNavigate()
  const loc = useLocation()
  const locState = loc.state as HistoryState
  const { employee } = useEmployee()
  const { familyMembersResponse: familyMembers } = useFamilyMembers()
  const { hasSensitiveAccess } = useClientInfo()
  const { readOnly } = useContext(ReadOnlyContext)

  return (
    <OverflowMenu
      button={
        <TertiaryButton
          id="employee-overflow-menu-button"
          data-cy="employee-overflow-menu-button"
          disabled={disabled}
          style={{}}
        >
          Flere handlinger <HorizontalDotsIcon />
        </TertiaryButton>
      }
    >
      {!readOnly && hasSensitiveAccess === true && (
        <OverflowMenuItem
          onSelect={() => {
            navigate(`/ansatt/${employee.id}/endre`, { state: { ...locState, employee } })
          }}
          className=".change-personal-data-btn"
          data-cy="change-personal-data-button"
        >
          <span aria-hidden>
            <UsersIcon inline />
          </span>
          Endre persondata
        </OverflowMenuItem>
      )}

      {employee.isDeleted ? (
        <RestoreEmployee />
      ) : (
        <>
          <WelcomeLetter familyMembers={familyMembers} setErrorMessage={setErrorMessage} />
          <PostalAddress familyMembers={familyMembers} setErrorMessage={setErrorMessage} />
          <DisclosureDocument setErrorMessage={setErrorMessage} />
        </>
      )}
    </OverflowMenu>
  )
}
